import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { useKeepMounted } from '@/components/keep-mounted';
import { setIsSchedulingFormOpen } from '../../redux/slices/schedulingFormSlice';

function SchedulingForm() {
  const isSchedulingFormOpen = useSelector(state => state.schedulingForm.isSchedulingFormOpen);
  const dispatch = useDispatch();
  const keepMounted = useKeepMounted();

  return (
    <>
      <Sheet
        open={isSchedulingFormOpen}
        onOpenChange={next => {
          if (!next) {
            dispatch(setIsSchedulingFormOpen(false));
          }
        }}
      >
        <SheetContent
          {...keepMounted.contentProps}
          aria-describedby={undefined}
          className="gap-0 data-[side=right]:w-full data-[side=right]:sm:max-w-[1000px]"
        >
          <SheetHeader className="border-b pe-14">
            <SheetTitle>Schedule a Meeting</SheetTitle>
          </SheetHeader>
          <div
            ref={keepMounted.outletRef}
            className="flex min-h-0 flex-1 flex-col overflow-y-auto p-6"
          />
        </SheetContent>
      </Sheet>
      {keepMounted.portal(
        <iframe
          title="calendly"
          className="size-full min-h-[500px]"
          src="https://meetings-eu1.hubspot.com/maanas-mediratta/customer-query"
          frameBorder="0"
        ></iframe>
      )}
    </>
  );
}

export default SchedulingForm;
